import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";
import CallIcon from "@mui/icons-material/Call";
import CallRequestConfirm from "./pageComponents/CallRequestConfirm";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TamasBaKarshenas({ requestToken, mobileNumber }) {
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [target, setTarget] = React.useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const linkStyle = {
    color: "#fff5ff",
    textDecoration: "none",
  };
  const handleCall = (id) => {
    setTarget(id);
    setMessage(
      "کاربر گرامی؛ تا لحظاتی دیگر تماس کارشناس انتخاب شده با شما برقرار خواهد شد، لطفا در صورت تمایل تایید نمایید "
    );
    setOpen(true);
  };
  const handleCallConfirm = async () => {
    setOpen(false);
    const res = await fetch(
      `/ng/api/HandleCallRequest?client=${mobileNumber}&token=${requestToken}&target=${target}`
    );
    const data = await res.json();
    setOpen(false);
    if (data.result === 4000) alert("درخواست شما معتبر نمی باشد");
  };
  return (
    <>
      <CallRequestConfirm
        content={message}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onConfirm={handleCallConfirm}
      />
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label=""
            variant="scrollable"
            //textColor="#c5c5c5"
          >
            <Tab label="واحد فروش" {...a11yProps(0)} />
            <Tab label="واحد تدارکات" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Stack spacing={2}>
            {[
              {
                name: "مژگان رحمانی",
                post: "مدیر فروش",
                email: "m.rahmani@negincompany.com",
                img: "rahmani.jpg",
                id: "S1",
              },
              {
                name: "جابر جمالی",
                post: "کارشناس فروش",
                email: "j.jamali@negincompany.com",
                img: "",
                id: "S2",
              },
              {
                name: "رامین توحیدی",
                post: "کارشناس فروش",
                email: "tohidi@negincompany.com",
                img: "",
                id: "S3",
              },
            ].map((p, index) => (
              <Stack key={index} direction="row" spacing={2}>
                {p.img === "" ? (
                  <Avatar sx={{ width: 150, height: 230 }} variant="square">
                    <PersonIcon fontSize="large" />
                  </Avatar>
                ) : (
                  <img
                    src={`http://negincompany.com/site/images/1399/${p.img}`}
                    alt="Logo"
                  />
                )}
                <Stack sx={{ paddingTop: 6 }} spacing={2}>
                  <Typography>{p.name}</Typography>
                  <Typography variant="body2">
                    پست سازمانی:
                    {p.post}
                  </Typography>
                  <Typography variant="body2">
                    ایمیل:
                    <a style={linkStyle} href={`mailto:${p.email}`}>
                      ارسال ایمیل
                    </a>
                  </Typography>
                  <CallIcon
                    color="success"
                    fontSize="large"
                    onClick={() => {
                      handleCall(p.id);
                    }}
                  />
                </Stack>
              </Stack>
            ))}
          </Stack>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Stack spacing={2}>
            {[
              {
                name: "علی جمشیدی",
                post: "کارشناس تدارکات",
                email: "jamshidi@negincompany.com",
                img: "jamshidi.jpg",
                id: "L2",
              },
            ].map((p, index) => (
              <Stack key={index} direction="row" spacing={2}>
                <img
                  src={`http://negincompany.com/site/images/1399/${p.img}`}
                  alt="Logo"
                />
                <Stack sx={{ paddingTop: 6 }} spacing={2}>
                  <Typography>{p.name}</Typography>
                  <Typography variant="body2">
                    پست سازمانی:
                    {p.post}
                  </Typography>
                  <Typography variant="body2">
                    ایمیل:
                    <a style={linkStyle} href={`mailto:${p.email}`}>
                      ارسال ایمیل
                    </a>
                  </Typography>
                  <CallIcon
                    color="success"
                    fontSize="large"
                    onClick={() => {
                      handleCall(p.id);
                    }}
                  />
                </Stack>
              </Stack>
            ))}
          </Stack>
        </TabPanel>
      </Box>
    </>
  );
}
